import React from "react";

const Footer = () => {
    return (
        <div className={"component"} id={"footer"}>
            <h2>További információkért látogassa meg a
                <a href={"http://www.fazekasbolt.hu/index.html"} target={"_blank" } rel="noopener noreferrer"> Fazekasbolt.hu</a>-t
            </h2>
        </div>
    );
}

export default Footer;